import * as React from 'react';
import {useSelector, RootStateOrAny} from "react-redux"
import { useTranslation } from "react-i18next";
import { ITextStyles, Text, mergeStyles } from "office-ui-fabric-react";
import { FontSizes } from "@uifabric/fluent-theme";

const headerContainer = mergeStyles({
    marginBottom: "35px",
    display: "flex",
    flexDirection: "column",
  });
  
  export const headerS: ITextStyles = {
    root: {
      fontSize: FontSizes.size24,
      marginBottom: 20
    },
  };
 
const AlredyRegisteredHeader: React.SFC = () => {
    const { t } = useTranslation("admin");
    const {company} = useSelector((state: RootStateOrAny) => state.register)
    return (
        <div className={headerContainer}>
            <Text styles={headerS}>
              {t("auth.messages.companyNipExists")}
            </Text>
            <Text>{company.data.name}</Text>
        </div>
     );
}
 
export default AlredyRegisteredHeader;